const itemsKey = items => JSON.stringify((Array.isArray(items) ? items : []).map(String).sort());
export const findCartLineIndex = (lines, payload) => {
  if (payload.cartLineId != null) return lines.findIndex(line => line.id === payload.cartLineId);
  if (payload.key != null) return lines.findIndex(line => line.key === payload.key);
  const productId = payload.productId || payload.Product?.productId;
  if (!productId) return -1;
  return lines.findIndex(line =>
    (line.productId || line.Product?.productId) === productId &&
    (line.variantId || "") === (payload.variantId || "") &&
    itemsKey(line.itemIds) === itemsKey(payload.itemIds) &&
    (line.note || "") === (payload.note || "")
  );
};
